import { Col, Modal, Row } from "antd";
import { Notifications } from "src/containers/myAccount/Notification";
import { ListHeaderItem } from "src/containers/myAccount/styles";
import { TeamMemberActions } from "src/containers/teamMembers/teamMemberReducer";
import { Button } from "src/designsystem/Button/Button";
import { IUser } from "src/modules/myAccount/types";
import { Dispatch, memo } from "react";

export const TeamMemberNotification = memo(
  ({
    member,
    visibility,
    dispatch,
  }: {
    member?: IUser;
    visibility: boolean;
    dispatch: Dispatch<TeamMemberActions>;
  }) => {
    if (!member) {
      return null;
    }
    return (
      <Modal
        title="Notification Preferences"
        visible={visibility}
        closeIcon={<></>}
        width={800}
        footer={
          <Button
            variant="primary"
            onClick={() => {
              dispatch({
                type: "SET_NOTIFICATIONS_MODAL_VISIBILITY",
                notificationModal: false,
              });
            }}
          >
            Done
          </Button>
        }
        onCancel={() => {
          dispatch({
            type: "SET_NOTIFICATIONS_MODAL_VISIBILITY",
            notificationModal: false,
          });
          dispatch({ type: "SET_MODAL_MEMBER", member: undefined });
        }}
      >
        <Row
          justify-content={"space-between"}
          align={"middle"}
          style={{
            marginTop: "-52px",
            transform: "translateY(-10px)",
          }}
        >
          <Col span={15}></Col>
          <ListHeaderItem span={3} style={{ fontSize: 16 }}>
            Email
          </ListHeaderItem>
          <ListHeaderItem span={3} style={{ fontSize: 16 }}>
            SMS
          </ListHeaderItem>
          <ListHeaderItem span={3} style={{ fontSize: 16 }}>
            Web Push
          </ListHeaderItem>
        </Row>
        <Notifications member={member} />
      </Modal>
    );
  }
);
